'use client'
import '@dynamic-labs/store';
import '@dynamic-labs/utils';
import '../../../constants/colors.js';
import '../../../constants/values.js';
import { getDidStoreVersionChangedValue, setDidStoreVersionChangedValue } from '../../../../store/utils/didStoreVersionChanged/didStoreVersionChanged.js';

const handleStoreVersionChanged = ({ logout, }) => {
    if (getDidStoreVersionChangedValue()) {
        setDidStoreVersionChangedValue(false);
        logout('dynamic SDK version changed', {});
    }
};

export { handleStoreVersionChanged };
